import { LocalisationLanguages, Translations } from '../types';
import { translationsDE } from './de';
import { translationsEN } from './en';

export const translations: Record<LocalisationLanguages, Translations> = {
  en: {
    ...translationsEN,
  },
  de: {
    ...translationsDE,
  },
};
